export default "__VITE_ASSET__BMS9nTos__"